import Basic from './basic.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': Basic
};
